var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',{attrs:{"has-background":true,"contained":true}},[_c('admin-billing-table',{attrs:{"apiUrl":"/admin-tools/get-billing-events"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }